import type { NamedFieldProps } from "./Field.js";
import { OptionalSchema, getOptionalSource } from "shelving";
import { Field, useField } from "./Field.js";
import { FieldNotice } from "./FieldNotice.js";
import { RangeInput } from "./RangeField.js";

export function HueField(props: NamedFieldProps): React.ReactElement {
	const field = useField<number | null>(props);
	const { name, form, schema, fullplaceholder, value } = field;
	return (
		<Field {...field}>
			<RangeInput //
				name={name}
				mods="fill-rainbow space-none"
				required={!getOptionalSource(OptionalSchema, schema)}
				step={1}
				min={0}
				max={360}
				placeholder={fullplaceholder}
				value={value ?? 0}
				onValue={num => form.publish(name, num)}
			/>
			<FieldNotice name={name} />
		</Field>
	);
}
